/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Partner_Org_Kpi_Used_Ai_BadgeInputs */



/**
* | output |
* | --- |
* | "of {total} members, this period" |
*
* @param {Partner_Org_Kpi_Used_Ai_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_kpi_used_ai_badge = /** @type {((inputs: Partner_Org_Kpi_Used_Ai_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Kpi_Used_Ai_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`von ${i?.total} Mitgliedern, in diesem Zeitraum`)
	return /** @type {LocalizedString} */ (`of ${i?.total} members, this period`)
});